export const CLIENT_SECRET = import.meta.env.VITE_CLIENT_SECRET;
export const mockAccount = {
	certificates: [],
	email: 'andranik.mkhitaryan@newo.ai',
	id: 'cbf91412-4113-431d-bb78-759c374f256d',
	idn: 'MVBbIXgzH',
	name: 'andranik.mkhitaryan@newo.ai',
	role: 'admin',
	scopes: []
};
